import Header from "../../component/Header";
import Layout from "../../component/Layout";
import UsePagination from "../../component/pagination";
import * as S from "./modal.styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import SelectComponent from "../../common/textFeilds/SelectComponent";
import { useEffect, useState } from "react";
import VerifyModal from "../../component/Modal/verifyModal";
import axios from "axios";
import urls from "../../utils";
import { toast } from "react-toastify";
import "../../component/pagination/pagination.css";
import { p2e } from "../../common/price";
import Modal from ".";
const MobileVerify = ({ step, setStep, open, onClose }) => {
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [verifySeccess, setVerifySeccess] = useState(false);
  const [openModal, setOpenModal] = useState(open);
  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  const initialValues = {
    mobile: "",
  };
  const onSubmit = (values) => {
    if (formik.values.mobile) {
      const data = {
        mobile: p2e(values.mobile),
      };
      console.log(values);
      axios
        .post(urls.sendOtp, data)
        .then((res) => {
          setOpenModalSearch(true);
          toast.success(res.data.message);
          setVerifySeccess((prev) => prev === true && true);
          onClose();
        })
        .catch((err) => {
          setVerifySeccess((prev) => prev === false && false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      setOpenModalSearch(false);
    }
  };

  const validationSchema = Yup.object({
    mobile: Yup.string()
      .required(" شماره را وارد کنید")
      .matches(
        /((\+98|0)?9\d{9})|((\+۹۸|۰)?۹[۰-۹]{9})$/,
        "شماره را صحیح وارد کنید"
      ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <>
      <VerifyModal
        open={openModalSearch}
        mobile={formik.values.mobile && p2e(formik.values.mobile)}
        onClose={() => setOpenModalSearch(false)}
        setVerifySeccess={setVerifySeccess}
        verifySeccess={verifySeccess}
      />

      <Modal>
        <S.ModalContainer active={openModal}>
          {onClose ? (
            <S.ModalContainerBg
              $active={openModal}
              onClick={() => onClose()}
            ></S.ModalContainerBg>
          ) : (
            <S.ModalContainerBg $active={openModal}></S.ModalContainerBg>
          )}
          <S.ModalContainerContent $active={openModal}>
            <div className="content">
              <S.TitleModal>
                <S.Title> ارسال شماره تماس</S.Title>
                <S.BtnClose onClick={onClose}>
                  <S.CloseSvg as={CloseIcon} />
                </S.BtnClose>
              </S.TitleModal>
              <form onSubmit={formik.handleSubmit}>
                <S.WrapperVerify>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "5px 0px",
                      width: "100%",
                    }}
                  >
                    <S.Lable>
                      شماره تماس
                      <S.Requierd>*</S.Requierd>
                    </S.Lable>
                    <S.InputField
                      type={"text"}
                      {...formik.getFieldProps("mobile")}
                      name={"mobile"}
                    />
                    <S.ErrorMessage>
                      {formik.errors["mobile"] && formik.touched["mobile"] && (
                        <div className="error">{formik.errors["mobile"]}</div>
                      )}
                    </S.ErrorMessage>
                  </div>

                  <S.BtnConfirmation
                    className="btnnex"
                    type="submit"
                    disabled={!formik.isValid}
                  >
                    ارسال
                  </S.BtnConfirmation>
                </S.WrapperVerify>
              </form>
            </div>
          </S.ModalContainerContent>
        </S.ModalContainer>
      </Modal>
    </>
  );
};

export default MobileVerify;
